import React from 'react';

const deleteKeySet = new Set(['Backspace', 'Delete']);

export const isDeleteEvent = <H extends HTMLElement = HTMLElement>({
  key,
}: React.KeyboardEvent<H> | KeyboardEvent) => deleteKeySet.has(key);

export default isDeleteEvent;
